import React from 'react'
import { ResponsiveTable, ResponsiveCheckboxTable } from '@fs/zion-ui'
import { useRoleIndicatorRef } from '../app/RoleIndicatorRefContext'

export function DmcResponsiveTable({ stickyHeader = true, ...props }) {
  const roleIndicatorRef = useRoleIndicatorRef()
  return <ResponsiveTable stickyHeader={stickyHeader} stickyBelowRef={roleIndicatorRef} {...props} />
}

export function DmcResponsiveCheckboxTable({ stickyHeader = true, ...props }) {
  const roleIndicatorRef = useRoleIndicatorRef()
  return <ResponsiveCheckboxTable stickyHeader={stickyHeader} stickyBelowRef={roleIndicatorRef} {...props} />
}
